var path = '/app-lite/grids/templates/cell.editable.html';
var html = "<input class=\"form-control\" maxlength=\"255\"\n  data-ng-class=\"'colt' + col.index\"\n  data-ng-input=\"COL_FIELD\"\n  data-ng-model=\"COL_FIELD\"\n  editable-cell />";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;